import { useTeam } from "@repo/api";
import { Text, type TextProps } from "@repo/skapa";
import { t } from "@repo/translation";

interface Props {
  teamId?: number | null;
  showTeamId?: boolean;
  textStyle?: TextProps["textStyle"];
  fragment?: boolean;
}

export const TeamName = ({
  teamId,
  showTeamId = true,
  textStyle,
  fragment,
}: Props) => {
  const { data } = useTeam(teamId);
  const teamName = data?.teamName ?? teamId;
  const displayName = showTeamId
    ? `${teamName} (${t("label.ID")}: ${teamId})`
    : teamName;
  if (fragment) {
    return <>{displayName}</>;
  }
  return (
    <Text textStyle={textStyle} noWrap ellipsis>
      {displayName}
    </Text>
  );
};
